<script setup>

import {ref, onMounted} from "vue";
import Tooltip from "@/components/ui/Tooltip.vue";

const DEBOUNCE_MS = 400;

const props = defineProps({
    filterId: { type: String, required: true },
    label:    { type: String, required: true },
    placeholder: { type: String, required: false },
    tooltip: { type: String, required: false },
});

const model = defineModel();

const localValue = ref(null);

onMounted(() => {
    const params = new URLSearchParams(window.location.search);
    const urlValue = params.get(props.filterId);
    if (urlValue !== null) {
        setTimeout(() => {
            localValue.value = urlValue;
            model.value = urlValue;
        })
    }
});

let timer;
const onInput = (event) => {
    localValue.value = event.target.value;
    clearTimeout(timer);
    timer = setTimeout(() => {
        model.value = event.target.value;
    }, DEBOUNCE_MS);
};

const clear = () => {
    model.value = null;
    localValue.value = null;
};

defineExpose({ clear });
</script>

<template>
    <b-field :label="label" custom-class="mb-3">
        <b-input :id="filterId" :value="localValue" :placeholder="placeholder" @input="onInput"/>
        <template #label v-if="tooltip">
            <Tooltip :text="tooltip">
                <div class="is-flex is-align-items-center" style="gap: 4px">
                    <b-icon size="is-small" icon="help-circle-outline"/>
                    {{ label }}
                </div>
            </Tooltip>
        </template>
    </b-field>
</template>
